module.exports = __webpack_public_path__ + "static/img/goinglobal.e47da14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goinglobal.jpg
// module id = HjDf
// module chunks = 1